import { render, staticRenderFns } from "./markdown-parser.html?vue&type=template&id=4b49beda&scoped=true&"
import script from "./markdown-parser.js?vue&type=script&lang=js&"
export * from "./markdown-parser.js?vue&type=script&lang=js&"
import style0 from "./markdown-parser.scss?vue&type=style&index=0&id=4b49beda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49beda",
  null
  
)

export default component.exports